export const HEADER_PROFILE = {
  LOGOUT: 'logoutButton',
};
